import Blue from "../core";

new Blue({
	name: 'Page Nav',
	selector: ".page-nav",
	setup(nav) {
		const links = [...nav.querySelectorAll('a.page-nav__item')];
		const linkedItems = links.map(link => {
			const href = link.getAttribute('href');
			return document.querySelector(href) || null;
		});
		
		let isScrolling = false;
		
		const scrollSectionIntoView = link => {
			if (!link) return;
			const href = link.getAttribute('href');
			const section = document.querySelector(href);
			if (!!section) {
				section.scrollIntoView({ behavior: 'smooth' });
				document.querySelector('.page-nav__item.is-active')?.classList.remove('is-active');
				link.classList.add('is-active');
			}
		}

		links.forEach(link => {
			this.$addEvents(link, 'click.prevent', () => {
				isScrolling = true;
				scrollSectionIntoView(link);
				setTimeout(() => isScrolling = false, 750);
			});
		});

		const throttle = (func, limit) => {
			let inThrottle;
			return function() {
				const args = arguments;
				const context = this;
				if (!inThrottle) {
					func.apply(context, args);
					inThrottle = true;
					setTimeout(() => inThrottle = false, limit);
				}
			}
		}

		const checkActiveSection = () => {
			if (isScrolling) return;
			let topLinkedItem = linkedItems.find(item => {
				const rect = item.getBoundingClientRect();
				return rect.top >= 0 && rect.bottom < window.innerHeight;
			});	
			if (!topLinkedItem) {
				linkedItems.forEach(item => {
					const rect = item.getBoundingClientRect();
					if (rect.top < 0) {
						topLinkedItem = item;
					}
				});
			}
			const index = linkedItems.indexOf(topLinkedItem);
			const activeLink = links[index];
			document.querySelector('.page-nav__item.is-active')?.classList.remove('is-active');
			activeLink.classList.add('is-active');
		}

		window.addEventListener('scroll', throttle(checkActiveSection, 100));
		checkActiveSection();
			
	}
});